const state = {
  buttonClicked: "",
  isDialogOpen: false,
  layerMoved: null,
  pdfCreated: {
    dirname: "",
    files: "",
  },
};

const mutations = {
  BUTTONCLICKED(state, destination) {
    state.buttonClicked = destination;
  },
  BUTTONRESET(state) {
    state.buttonClicked = "";
  },
  DIALOGCLOSE(state) {
    state.isDialogOpen = false;
  },
  DIALOGOPEN(state) {
    state.isDialogOpen = true;
  },
  LAYERMOVED(state, layer) {
    state.layerMoved = layer;
  },
  PDFCREATED(state, obj) {
    state.pdfCreated = obj;
  },
  PDFRESET(state) {
    state.pdfCreated = {
      dirname: "",
      files: "",
    };
  },
};

const actions = {
  buttonClicked({ commit }, destination) {
    commit("BUTTONCLICKED", destination);
  },
  buttonReset({ commit }) {
    commit("BUTTONRESET");
  },
  dialogClose({ commit }) {
    commit("DIALOGCLOSE");
  },
  dialogOpen({ commit }) {
    commit("DIALOGOPEN");
  },
  layerMoved({ commit }, layer) {
    commit("LAYERMOVED", layer);
  },
  pdfCreated({ commit }, obj) {
    commit("PDFCREATED", obj);
  },
  pdfReset({ commit }) {
    commit("PDFRESET");
  },
};

export default {
  state,
  mutations,
  actions,
};
